import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface PlansPrice {
  id: number;
  price: number;
  planId: number;
  startDate: Date;
  createdAt: Date;
  inactivatedAt?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class PlansPriceService {
  private apiUrl = `${environment.api}/plans`;

  constructor(private http: HttpClient) {}

  getPrices(planId: number, page: number = 1, search: string = ''): Observable<any> {
    const params = { page: page.toString(), search };
    return this.http.get(`${this.apiUrl}/${planId}/prices`, { params });
  }

  createPrice(planId: number, price: number, startDate: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/${planId}/prices`, { price, startDate });
  }

  deletePrice(planId: number, priceId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${planId}/prices/${priceId}`);
  }
}
